// Auto-generated from /Users/catchpad/Downloads/Grade 1/
// Swatches are served as static assets from public/fabrics/grade-1/
// Filenames use underscores instead of spaces (webpack-dev-server doesn't serve paths with spaces).

const FABRIC_LIBRARY = {
  Fabric: {
    Antic: [
      { name: 'Chocolate', url: '/fabrics/grade-1/Fabric/Antic/Antic_Chocolate.jpg' },
      { name: 'Cinder', url: '/fabrics/grade-1/Fabric/Antic/Antic_Cinder.jpg' },
      { name: 'Fawn', url: '/fabrics/grade-1/Fabric/Antic/Antic_Fawn.jpg' },
      { name: 'Jade', url: '/fabrics/grade-1/Fabric/Antic/Antic_Jade.jpg' },
      { name: 'Lagoon', url: '/fabrics/grade-1/Fabric/Antic/Antic_Lagoon.jpg' },
      { name: 'Mimosa', url: '/fabrics/grade-1/Fabric/Antic/Antic_Mimosa.jpg' },
      { name: 'Navy', url: '/fabrics/grade-1/Fabric/Antic/Antic_Navy.jpg' },
      { name: 'Pepper', url: '/fabrics/grade-1/Fabric/Antic/Antic_Pepper.jpg' },
      { name: 'Sahara', url: '/fabrics/grade-1/Fabric/Antic/Antic_Sahara.jpg' },
      { name: 'Shell', url: '/fabrics/grade-1/Fabric/Antic/Antic_Shell.jpg' },
      { name: 'Slate', url: '/fabrics/grade-1/Fabric/Antic/Antic_Slate.jpg' },
    ],
    Beso: [
      { name: 'Aqua', url: '/fabrics/grade-1/Fabric/Beso/Beso_Aqua.jpg' },
      { name: 'Capri', url: '/fabrics/grade-1/Fabric/Beso/Beso_Capri.jpg' },
      { name: 'Chalice', url: '/fabrics/grade-1/Fabric/Beso/Beso_Chalice.jpg' },
      { name: 'Coral', url: '/fabrics/grade-1/Fabric/Beso/Beso_Coral.jpg' },
      { name: 'Dusk', url: '/fabrics/grade-1/Fabric/Beso/Beso_Dusk.jpg' },
      { name: 'Flaxen', url: '/fabrics/grade-1/Fabric/Beso/Beso_Flaxen.jpg' },
      { name: 'Graphite', url: '/fabrics/grade-1/Fabric/Beso/Beso_Graphite.jpg' },
      { name: 'Harbor', url: '/fabrics/grade-1/Fabric/Beso/Beso_Harbor.jpg' },
      { name: 'Jute', url: '/fabrics/grade-1/Fabric/Beso/Beso_Jute.jpg' },
      { name: 'Lupine', url: '/fabrics/grade-1/Fabric/Beso/Beso_Lupine.jpg' },
      { name: 'Magenta', url: '/fabrics/grade-1/Fabric/Beso/Beso_Magenta.jpg' },
      { name: 'Onyx', url: '/fabrics/grade-1/Fabric/Beso/Beso_Onyx.jpg' },
      { name: 'Peridot', url: '/fabrics/grade-1/Fabric/Beso/Beso_Peridot.jpg' },
      { name: 'Scarlet', url: '/fabrics/grade-1/Fabric/Beso/Beso_Scarlet.jpg' },
      { name: 'Silver', url: '/fabrics/grade-1/Fabric/Beso/Beso_Silver.jpg' },
      { name: 'Stone', url: '/fabrics/grade-1/Fabric/Beso/Beso_Stone.jpg' },
    ],
    Boothby: [
      { name: 'Bisbee', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Bisbee.jpg' },
      { name: 'Blazer', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Blazer.jpg' },
      { name: 'Castlerock', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Castlerock.jpg' },
      { name: 'Cerulean', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Cerulean.jpg' },
      { name: 'Glacier', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Glacier.jpg' },
      { name: 'Herb', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Herb.jpg' },
      { name: 'Jalapeno', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Jalapeno.jpg' },
      { name: 'Luna', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Luna.jpg' },
      { name: 'Marble', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Marble.jpg' },
      { name: 'Nickel', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Nickel.jpg' },
      { name: 'Whitecap', url: '/fabrics/grade-1/Fabric/Boothby/Boothby_Whitecap.jpg' },
    ],
    Montgomery: [
      { name: 'Bermuda', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Bermuda.jpg' },
      { name: 'Black', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Black.jpg' },
      { name: 'Cocoa', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Cocoa.jpg' },
      { name: 'Grape', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Grape.jpg' },
      { name: 'Iron', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Iron.jpg' },
      { name: 'Lime', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Lime.jpg' },
      { name: 'Melon', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Melon.jpg' },
      { name: 'Midnight', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Midnight.jpg' },
      { name: 'Mushroom', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Mushroom.jpg' },
      { name: 'Red Pepper', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Red_Pepper.jpg' },
      { name: 'Sterling', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Sterling.jpg' },
      { name: 'Taffy', url: '/fabrics/grade-1/Fabric/Montgomery/Montgomery_Taffy.jpg' },
    ],
    Ridgecrest: [
      { name: 'Beach', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Beach.jpg' },
      { name: 'Bittersweet', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Bittersweet.jpg' },
      { name: 'Chocolate', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Chocolate.jpg' },
      { name: 'Ink', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Ink.jpg' },
      { name: 'Meadow', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Meadow.jpg' },
      { name: 'Midnight', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Midnight.jpg' },
      { name: 'Mink', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Mink.jpg' },
      { name: 'Putty', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Putty.jpg' },
      { name: 'Ruby', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Ruby.jpg' },
      { name: 'Sterling', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Sterling.jpg' },
      { name: 'Taupe', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Taupe.jpg' },
      { name: 'Tidepool', url: '/fabrics/grade-1/Fabric/Ridgecrest/Ridgecrest_Tidepool.jpg' },
    ],
  },
  Velvet: {
    Bravia: [
      { name: 'Azure', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Azure.jpg' },
      { name: 'Blush', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Blush.jpg' },
      { name: 'Brocade', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Brocade.jpg' },
      { name: 'Cascade', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Cascade.jpg' },
      { name: 'Char', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Char.jpg' },
      { name: 'Cobalt', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Cobalt.jpg' },
      { name: 'Dune', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Dune.jpg' },
      { name: 'Emerald', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Emerald.jpg' },
      { name: 'Gold', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Gold.jpg' },
      { name: 'Heather', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Heather.jpg' },
      { name: 'Lipstick', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Lipstick.jpg' },
      { name: 'Midnight', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Midnight.jpg' },
      { name: 'Path', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Path.jpg' },
      { name: 'Plum', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Plum.jpg' },
      { name: 'Putty', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Putty.jpg' },
      { name: 'Sienna', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Sienna.jpg' },
      { name: 'Slate', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Slate.jpg' },
      { name: 'Surf', url: '/fabrics/grade-1/Velvet/Bravia/Bravia_Surf.jpg' },
    ],
  },
  Vinyl: {
    Impulse: [
      { name: 'Abalone', url: '/fabrics/grade-1/Vinyl/Impulse/ABALONEHR_1512x.webp' },
      { name: 'Adriatic', url: '/fabrics/grade-1/Vinyl/Impulse/ADRIATICHR_1512x.jpg' },
      { name: 'Bayside', url: '/fabrics/grade-1/Vinyl/Impulse/BAYSIDEHR_1512x.jpg' },
      { name: 'Caramel', url: '/fabrics/grade-1/Vinyl/Impulse/CARAMELHR_720x.jpg' },
      { name: 'Cloth', url: '/fabrics/grade-1/Vinyl/Impulse/CLOTHHR_1512x.webp' },
      { name: 'Cobalt', url: '/fabrics/grade-1/Vinyl/Impulse/COBALTHR_1512x.webp' },
      { name: 'Dolphin', url: '/fabrics/grade-1/Vinyl/Impulse/DOLPHINHR_1512x.webp' },
      { name: 'Ebony', url: '/fabrics/grade-1/Vinyl/Impulse/EBONYHR_91e3154b-6960-4ed5-8d37-d7d8da7e0813_1512x.jpg' },
      { name: 'Espresso', url: '/fabrics/grade-1/Vinyl/Impulse/ESPRESSOHR_1512x.jpg' },
      { name: 'Falcon', url: '/fabrics/grade-1/Vinyl/Impulse/FALCONHR_1512x.webp' },
      { name: 'Flora', url: '/fabrics/grade-1/Vinyl/Impulse/FLORAHR_1512x.jpg' },
      { name: 'Indigo', url: '/fabrics/grade-1/Vinyl/Impulse/INDIGOHR_1512x.webp' },
      { name: 'Iron', url: '/fabrics/grade-1/Vinyl/Impulse/IRONHR_1512x.webp' },
      { name: 'Java', url: '/fabrics/grade-1/Vinyl/Impulse/JAVAHR_1512x.jpg' },
      { name: 'Kelp', url: '/fabrics/grade-1/Vinyl/Impulse/KELPHR_1512x.jpg' },
      { name: 'Lipstick', url: '/fabrics/grade-1/Vinyl/Impulse/LIPSTICKHR_1512x.jpg' },
      { name: 'Maple', url: '/fabrics/grade-1/Vinyl/Impulse/MAPLEHR_1512x.jpg' },
      { name: 'Monochrome', url: '/fabrics/grade-1/Vinyl/Impulse/MONOCHROMEHR_1512x.webp' },
      { name: 'Pewter', url: '/fabrics/grade-1/Vinyl/Impulse/PEWTERHR_1512x.jpg' },
      { name: 'Pine', url: '/fabrics/grade-1/Vinyl/Impulse/PINEHR_1512x.jpg' },
      { name: 'Raisin', url: '/fabrics/grade-1/Vinyl/Impulse/RAISINHR_1512x.jpg' },
      { name: 'Snow', url: '/fabrics/grade-1/Vinyl/Impulse/SNOWHR_1512x.webp' },
      { name: 'Steel', url: '/fabrics/grade-1/Vinyl/Impulse/STEELHR_1512x.webp' },
      { name: 'Sungold', url: '/fabrics/grade-1/Vinyl/Impulse/SUNGOLDHR_1512x.webp' },
      { name: 'Tangerine', url: '/fabrics/grade-1/Vinyl/Impulse/TANGERINEHR_720x.jpg' },
      { name: 'Tanzanite', url: '/fabrics/grade-1/Vinyl/Impulse/TANZANITEHR_720x.jpg' },
      { name: 'Voyager', url: '/fabrics/grade-1/Vinyl/Impulse/VOYAGERHR_1512x.webp' },
    ],
    'New Soho': [
      { name: 'Am Beauty', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-001_NEW_SOHO_AM_BEAUTY_LR.png' },
      { name: 'Aqua Green', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-002_NEW_SOHO_AQUA_GREEN_LR.png' },
      { name: 'Avocado', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-003_NEW_SOHO_AVOCADO_LR.png' },
      { name: 'Black Walnut', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-004_NEW_SOHO_BLACK_WALNUT_LR.png' },
      { name: 'Blue Ridge', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-005_NEW_SOHO_BLUE_RIDGE_LR.png' },
      { name: 'Bright Yellow', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-006_NEW_SOHO_BRIGHT_YELLOW_LR.png' },
      { name: 'Burgundy', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-007_NEW_SOHO_BURGUNDY_LR.png' },
      { name: 'Chocolate Chip', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-008_NEW_SOHO_CHOCOLATE_CHIP_LR.png' },
      { name: 'Claret', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-009_NEW_SOHO_CLARET_LR.png' },
      { name: 'Concord', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-010_NEW_SOHO_CONCORD_LR.png' },
      { name: 'Dark Cherry', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-012_NEW_SOHO_DARK_CHERRY_LR.png' },
      { name: 'Ebony', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-013_NEW_SOHO_EBONY_LR.png' },
      { name: 'Espresso', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-014_NEW_SOHO_ESPRESSO_LR.png' },
      { name: 'Forest', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-016_NEW_SOHO_FOREST_LR.png' },
      { name: 'Georgia Clay', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-017_NEW_SOHO_GEORGIA_CLAY_LR.jpg' },
      { name: 'Graphite', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-018_NEW_SOHO_GRAPHITE_LR.png' },
      { name: 'Indigo', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-020_NEW_SOHO_INDIGO_LR.png' },
      { name: 'Ivory', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-021_NEW_SOHO_IVORY_LR.jpg' },
      { name: 'Kelly Green', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-023_NEW_SOHO_KELLY_GREEN_LR.png' },
      { name: 'Mushroom', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-025_NEW_SOHO_MUSHROOM_LR.jpg' },
      { name: 'Pearl', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-027_NEW_SOHO_PEARL_LR.png' },
      { name: 'Plum', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-028_NEW_SOHO_PLUM_LR.png' },
      { name: 'Royal Blue', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-029_NEW_SOHO_ROYAL_BLUE_LR.jpg' },
      { name: 'Sand', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-030_NEW_SOHO_SAND_LR.png' },
      { name: 'Silver Grey', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-031_NEW_SOHO_SILVER_GREY_LR.png' },
      { name: 'Silver Surf', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-032_NEW_SOHO_SILVER_SURF_LR.png' },
      { name: 'Sky Blue', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-033_NEW_SOHO_SKY_BLUE_LR.jpg' },
      { name: 'Super White', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-034_NEW_SOHO_SUPER_WHITE_LR.png' },
      { name: 'Tan', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-035_NEW_SOHO_TAN_LR.png' },
      { name: 'Tea Rose', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-037_NEW_SOHO_TEA_ROSE_LR.png' },
      { name: 'Tiger Lily', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-038_NEW_SOHO_TIGER_LILY_LR.png' },
      { name: 'Yellow Gold', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-040_NEW_SOHO_YELLOW_GOLD_LR.png' },
      { name: 'Yew Green', url: '/fabrics/grade-1/Vinyl/NEW_SOHO/VNS-041_NEW_SOHO_YEW_GREEN_LR.png' },
    ],
  },
};

// Material properties per type — controls how the swatch behaves in 3D
export const MATERIAL_PROPERTIES = {
  Fabric: { roughness: 0.85, metalness: 0, envMapIntensity: 0.3, repeat: 4 },
  Velvet: { roughness: 0.6, metalness: 0, envMapIntensity: 0.7, repeat: 3 },
  Vinyl: { roughness: 0.45, metalness: 0.05, envMapIntensity: 0.6, repeat: 3 },
};

export default FABRIC_LIBRARY;
